function getLocalStorageState<T = unknown>(key: string, defaultValue?: T, checkForCorrect?: (value?: T) => value is T): [T | undefined, (v: T) => void] {
    let value: T = undefined;

    try {
        const savedValues = JSON.parse(localStorage.getItem(key));
        if (checkForCorrect(savedValues)) {
            value = savedValues;
        } else {
            localStorage.removeItem(key);
            value = defaultValue;
        }
    } catch (e) {
        localStorage.removeItem(key);
        value = defaultValue;
    }

    const setValue = (value: T) => {
        if (!checkForCorrect(value)) return;
        localStorage.setItem(key, JSON.stringify(value));
    };

    return [value, setValue];
}

export default getLocalStorageState;
